import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { CuentaMatriculaModel } from "../shared/models/cuenta-matricula-model";
@Injectable()
export class SectionsService extends BaseService {
  constructor(public http: HttpClient) {
    super(http);
  }


  /**
   * @author Jose Wilson Mulato
   * @description El sistema envia los datos para crear la donacion
   * @param data
   */
  public async matricularCuenta(data: CuentaMatriculaModel) {
    let url: string = `matricularCuenta`;
    return this.Post(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sections.service.ts